import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const PopoverContent = ({ content, position, onClose }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return createPortal(
    <div
      ref={popoverRef}
      style={{
        position: "absolute",
        left: `${position.left}px`,
        top: `${position.top}px`,
        zIndex: 1000,
        backgroundColor: "#333",
        color: "#fff",
        borderRadius: "4px",
        padding: "6px 10px",
        fontSize: "12px",
        whiteSpace: "nowrap",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        transform: "translateX(-50%)",
      }}
    >
      {content}
      <div
        style={{
          position: "absolute",
          bottom: "-5px",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderLeft: "5px solid transparent",
          borderRight: "5px solid transparent",
          borderTop: "5px solid #333",
        }}
      />
    </div>,
    document.body
  );
};

const NotificationButton = (props) => {
  const context = props.context.componentParent;
  const indent = props.data.indent || {};
  const unreadCount = indent.notification_count;

  const [showPopover, setShowPopover] = useState(false);
  const [position, setPosition] = useState({ left: 0, top: 0 });

  const handleClick = (type, e) => {
    e.stopPropagation();
    if (type === "notification") {
      context.fetchNotificationsData(props);
    }
  };

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      left: rect.left + rect.width / 2,
      top: rect.top - 35 + window.scrollY, // above icon
    });
    setShowPopover(true);
  };

  const handleMouseLeave = () => {
    setShowPopover(false);
  };

  return (
    <div style={{ display: "flex", gap: "5px", position: "relative" }}>
      {indent.is_draft === 1 ? null : (
        <div
          style={{
            position: "relative",
            display: "inline-block",
            cursor: indent.notificationdatamap === 0 ? "not-allowed" : "pointer",
          }}
          onClick={(e) => {
            if (indent.notificationdatamap && indent.notificationdatamap !== 0) {
              handleClick("notification", e);
            }
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <img
            src={
              indent.notificationdatamap === 0
                ? require("../../assets/images/bell (1)disable.svg")
                : require("../../assets/images/bell (1).svg")
            }
            style={{
              position: "relative",
              pointerEvents: "none",
              marginTop: "-4px",
            }}
            alt="Notifications"
          />

          {unreadCount > 0 && (
            <span
              style={{
                position: "absolute",
                right: "-8px",
                top: "-1px",
                backgroundColor: "red",
                color: "white",
                borderRadius: "50%",
                padding: "2px 4px",
                fontSize: "8px",
                fontWeight: "bold",
                lineHeight: "1",
                pointerEvents: "none",
              }}
            >
              {unreadCount}
            </span>
          )}

          {showPopover && (
            <PopoverContent
              content="Notifications"
              position={position}
              onClose={() => setShowPopover(false)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationButton;
